import React, { useState } from 'react'
import CalendarService from "../../../services/CalendarService";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)
const InviteForm = () => {



    const [email, setEmail] = useState('');
    const [hasError, setHasError] = useState(false);



    const formValues = { email };


    const isNullOrWhitespace = value => {
        if (value instanceof String) {
            if (!value || value.trim() === '') {
                return true;
            }
        }

        return false;
    }

    const handleFormSubmit = e => {
        e.preventDefault();
        if (isNullOrWhitespace(email)) {
            setHasError(true);
        } else {
            CalendarService.sendInvite(formValues).then(() => {
                MySwal.fire({
                    title: "Invite sent",
                    showCancelButton: true,
                    showDenyButton: false,
                    showConfirmButton: false,
                    cancelButtonText: `Close`,
                })
            });
        }
    }

    return (
        <>
            <form className="w-full mt-6  px-4">
                <div className="input-group w-80">
                    <label className="font-medium text-xs text-gray-500">Email</label>
                    <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} className="input-field" />
                    {hasError && isNullOrWhitespace(email) && <span className="input-error">Please enter email.</span>}
                    <button type="submit" disabled style={{ display: "none" }} aria-hidden="true"></button>

                    <button type="submit" className="button without-icon bg-secondaryGradient mx-auto mt-5" onClick={e => handleFormSubmit(e)}>
                        Prosledi
                    </button>
                </div>

            </form>
        </>
    )
}

export default InviteForm;
